import {AbstractControl, ValidatorFn} from '@angular/forms';

import * as XRegExp_ from 'xregexp';

import {PasswordValidatorKey} from './custom-validator-keys';

const XRegExp = XRegExp_.default;

export function PasswordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const value = control.value;

        const passwordRegex =
            XRegExp('^(?=[\\x20-\\x7e]{8,}$)(?=.*[\\W_])(?=.*[A-Z])(?=.*[a-z])(?=.*\\d).+$');

        if (!passwordRegex.test(value)) {
            return {[PasswordValidatorKey]: true};
        }

        return null;
    };
}
